import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ProgressiveCertificationsView from './ProgressiveCertificationsView';
import constants from '../../constants';
import GoogleAnalytics from '@/presentation/hooks/useGoogleAnalytics';

const ProgressiveCertificationsController = () => {
  useEffect(() => {
    GoogleAnalytics.writeLog(
      'portal-course-progressiveCertifications',
      'course'
    );
  }, []);

  const history = useHistory();

  const handlerBack = () => history.push('/cursos');

  return (
    <ProgressiveCertificationsView
      handlerBack={handlerBack}
      subsectionHeader={constants.subsectionHeader}
    />
  );
};

export default ProgressiveCertificationsController;
